import React from "react";
import { Card, CardContent, Box, Typography, Skeleton } from "@mui/material";
import PropTypes from "prop-types";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import AutoMode from "./AutoModeConfig";

const FieldVsShopCard = ({
  data,
  renderHeader,
  loading,
  mode,
  setMode,
  handleStartCountdown,
}) => {
  return (
    <Card sx={cardStyle}>
      <CardContent sx={{ p: 1, "&:last-child": { pb: 1 }, height: "100%" }}>
        {renderHeader("Field / Shop", "fieldShop", mode)}

        {mode === "auto" ? (
          <AutoMode
            metricType="fieldShop"
            setMode={setMode}
            onApply={(metricType, duration) => {
              console.log(
                "[TotalDevicesCard] Apply pressed in AutoMode:",
                metricType,
                duration
              );
              // if (metricType === "fieldShop") {

              // }
              handleStartCountdown(
                metricType,
                parseInt(duration.replace("m", ""))
              );
            }}
          />
        ) : loading ? (
          <>
            <Box
              sx={{
                width: "100%",
                height: 150,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Skeleton variant="circular" width={80} height={80} />
            </Box>
            <Box
              sx={{ display: "flex", justifyContent: "space-around", mt: 0 }}
            >
              <Skeleton width={40} height={20} />
              <Skeleton width={40} height={20} />
              <Skeleton width={40} height={20} />
            </Box>
          </>
        ) : (
          <>
            <Box sx={{ width: "100%", height: 140 }}>
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={data}
                    dataKey="value"
                    nameKey="name"
                    cx="50%"
                    cy="50%"
                    outerRadius={60}
                  >
                    {data.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </Box>
            <Box
              sx={{ display: "flex", justifyContent: "space-around", mt: 3 }}
            >
              <Legend color="#22C55E" label="Field" />
              <Legend color="#FF9800" label="Shop" />
              <Legend color="#E5E7EB" label="Pending" />
            </Box>
          </>
        )}
      </CardContent>
    </Card>
  );
};

const COLORS = ["#22C55E", "#E5E7EB", "#FF9800"];

const cardStyle = {
  borderRadius: 2,
  boxShadow: 1,
  backgroundColor: "#F9FAFB",
  width: "100%",
  minWidth: 0,
  maxWidth: 320,
  p: 1,
  height: 260,
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
};

const Legend = ({ color, label }) => (
  <Box sx={{ display: "flex", alignItems: "center" }}>
    <Box
      sx={{
        width: 12,
        height: 12,
        borderRadius: "50%",
        backgroundColor: color,
        mr: 0.5,
      }}
    />
    <Typography variant="caption" sx={{ fontSize: "0.7rem" }}>
      {label}
    </Typography>
  </Box>
);

export default FieldVsShopCard;

FieldVsShopCard.propTypes = {
  data: PropTypes.array.isRequired,
  renderHeader: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  mode: PropTypes.string.isRequired,
  setMode: PropTypes.func.isRequired,
  handleStartCountdown: PropTypes.func.isRequired,
};

Legend.propTypes = {
  color: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};
